import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type SmartFormEditorEvents =
  | 'TAB_CHANGE'
  | 'RESTORE_DEFAULT'
  | 'RESTORE_DEFAULT_DIALOG_BUTTON'
  | 'RESTORE_DEFAULT_DIALOG_CANCEL'
  | 'FORMAT'
  | 'COPY';

export const smartFormEditor: Record<SmartFormEditorEvents, MixpanelEvent> = {
  TAB_CHANGE: {
    eventDescription: 'Smart Form Tab Clicked',
    eventKey: 'smart-form-tab-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.TAB
  },
  RESTORE_DEFAULT: {
    eventDescription: 'Restore Default Smart Form',
    eventKey: 'restore-default-smart-form',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  RESTORE_DEFAULT_DIALOG_BUTTON: {
    eventDescription: 'Restore Default Dialog Button Clicked',
    eventKey: 'restore-default-dialog-button-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  RESTORE_DEFAULT_DIALOG_CANCEL: {
    eventDescription: 'Restore Default Dialog Cancel Clicked',
    eventKey: 'restore-default-dialog-cancel-clicked',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CANCEL_BUTTON
  },
  FORMAT: {
    eventDescription: 'Format Smart Form',
    eventKey: 'smart-form-format',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  COPY: {
    eventDescription: 'Copy Smart Form',
    eventKey: 'smart-form-copy',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  }
} as const;
